import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { MailFlags, Snackbar } from '@le_cedre/portal-lib';
import { BehaviorSubject, Observable } from 'rxjs';
import { CedreHttpClient } from '../../../../core/http.service';

@Injectable({
    providedIn: 'root',
})
export class EmailValidationService {
    private state$ = new BehaviorSubject<MailFlags>({
        isLoading: false,
        isValid: false,
        isRefused: false,
    });

    get flags$(): Observable<MailFlags> {
        return this.state$.asObservable();
    }

    constructor(private http: CedreHttpClient, private snackbar: Snackbar) {}

    reset() {
        this.state$.next({
            isValid: false,
            isRefused: false,
            isLoading: false,
        });
    }

    async verify(email: string) {
        try {
            this.loading();
            const exist = await this.searchEmail(email);
            this.validate(exist);
        } catch (error) {
            this.snackbar.createSnackbarFromError(error);
        }
    }

    private loading() {
        this.state$.next({
            isValid: false,
            isRefused: false,
            isLoading: true,
        });
    }

    private validate(exist: boolean) {
        this.state$.next({
            isValid: !exist,
            isRefused: exist,
            isLoading: false,
        });
    }

    private async searchEmail(email: string): Promise<boolean> {
        const { urls } = environment;
        const response = await this.http.get<{ IsExist: boolean }>(`${urls.v2}lr/email?&email=${email}`);
        return response.IsExist;
    }
}
